import { useMutation, useQueryClient } from '@tanstack/react-query';
import { folderApi } from '@_entities/content';
import { predicateType } from '@_shared/libs';

export function useDeleteFolderMutation() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (folderId: string) => folderApi.deleteFolder(folderId),
		onSuccess: () => {
			queryClient.invalidateQueries({
				predicate: (query) => predicateType(query, 'folderList'),
				refetchType: 'all',
			});
		},
	});
}
